const groupWealthDetailParameterFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const parameterGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`parameter-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `parameter-${index}-title`)) {
      break;
    }

    parameterGroups.push({ index, fields: groupFields });
  }

  return { introFields, parameterGroups };
};

export default groupWealthDetailParameterFields;
